import styled, { css } from "styled-components";
const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1350px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 10px;
  & .work {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 20px;
  }
`;
export const NoData = styled.div`
  width: 100%;
  height: calc(100vh - 320px);
  margin: 0 auto;
  ${flexCenter}
`;
export const Actions = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  align-self: flex-end;
  /* padding: 10px 50px; */
`;
